import LiabilityTab from "../../../../patient/details/liability/LiabilityTab";

export default function LiabilityDrawerTab({classes, goToCaseTabHandler, column = 5, inWorkQ}) {
    
    return <div className={`${classes.block} ${classes[`block_${column}`]}`}>
        <LiabilityTab inWorkQ={inWorkQ} />
    </div>
}
